import api from "@/services/api.service";
export default {
  name: 'Contact_View',
  components: {},
  props: [],
  data () {
    return {
      items:{},
      event_fields: [
      {key: 'event',sortable: true},
      {key: 'request',sortable: true},
      {key: 'response',sortable: true},                
      ],
      permission_view: false,
      superAdmin: false
    }      
  },
    async created() {    
      let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
            response.data[0].permission.forEach( function(element) {                
                permissions.push(element.action)
            }.bind(this));
            if(permissions.includes("view_details_contact") == true){
              this.getContact();
              this.permission_view = permissions.includes("view_details_contact");
            }else if(response.data[0].role == 'super_admin'){
              this.getContact();
              this.superAdmin = true;
            }else if(permissions.includes("list_contact") == true || permissions.includes("add_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'List Contacts'});
            } else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }      
    },
    mounted () {

    },
    methods: {
      makeToast(message = '', title = 'Alert', variant = 'warning') 
        {
            this.toastCount++
            this.$root.$bvToast.toast(message, {
                title: title,
                variant: variant,
                autoHideDelay: 3000
            })
      },
      async getContact() {
        this.isBusy=true;
        let response = await api.post('contact/view', {id:this.$route.params.id});
        if (!response)
          this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
        if (response.status == 'success') {
          if (response.data != '')
            this.items = response.data
          else {
            this.items = [];
          }
        }
        this.isBusy=true;
      },
    }
  }


